module.exports = {
    AdminChecks: require('../fragments/AdminChecks').default,
    Application: require('../fragments/Application').default,
    Arrangement: require('../fragments/Arrangement').default,
    Arrangers: require('../fragments/Arrangers').default,
    AshesDetail: require('../fragments/AshesDetail').default,
    Audiovisuals: require('../fragments/Audiovisuals').default,
    AuthorisedContacts: require('../fragments/AuthorisedContacts').default,
    BdmResponse: require('../fragments/BdmResponse').default,
    BillTo: require('../fragments/BillTo').default,
    Cars: require('../fragments/Cars').default,
    Caterers: require('../fragments/Caterers').default,
    CateringStaffs: require('../fragments/CateringStaffs').default,
    CemeteryCremetorium: require('../fragments/CemeteryCremetorium').default,
    Certification: require('../fragments/Certification').default,
    ChildrenDetails: require('../fragments/ChildrenDetails').default,
    Clergy: require('../fragments/Clergy').default,
    CoffinBearings: require('../fragments/CoffinBearings').default,
    Conductors: require('../fragments/Conductors').default,
    Coordinators: require('../fragments/Coordinators').default,
    DeceasedPhotos: require('../fragments/DeceasedPhotos').default,
    DefaultMusicians: require('../fragments/DefaultMusicians').default,
    Disposal: require('../fragments/Disposal').default,
    EnterMusicSong: require('../fragments/EnterMusicSong').default,
    EnterMusicians: require('../fragments/EnterMusicians').default,
    ExitMusicSongs: require('../fragments/ExitMusicSongs').default,
    ExitMusicians: require('../fragments/ExitMusicians').default,
    Florists: require('../fragments/Florist').default,
    FuneralDressing: require('../fragments/FuneralDressing').default,
    Grave: require('../fragments/Grave').default,
    GraveDigger: require('../fragments/GraveDigger').default,
    GraveLedger: require('../fragments/GraveLedger').default,
    GravesideMusicSongs: require('../fragments/GravesideMusicSongs').default,
    GravesideMusicians: require('../fragments/GravesideMusicians').default,
    Hearse: require('../fragments/Hearse').default,
    Informant: require('../fragments/Informant').default,
    Invoices: require('../fragments/Invoices').default,
    LeadSource: require('../fragments/EnquiryLead').default,
    LegacyDocuments: require('../fragments/LegacyDocuments').Funeral,
    Lifestory: require('../fragments/Lifestory').default,
    LimoBookings: require('../fragments/Limos').default,
    Marriages: require('../fragments/Marriages').default,
    MemorialPhoto: require('../fragments/MemorialPhoto').default,
    MemorialStationary: require('../fragments/MemorialStationary').default,
    MortuaryLocation: require('../fragments/MortuaryLocation').default,
    NewspaperNotices: require('../fragments/NewspaperNotice').default,
    OtherMusicSongs: require('../fragments/OtherMusicSongs').default,
    OtherMusicians: require('../fragments/OtherMusicians').default,
    Parent1: require('../fragments/Parent1').default,
    Parent2: require('../fragments/Parent2').default,
    PersonalisedTouches: require('../fragments/PersonalisedTouches').default,
    PlaceOfDeath: require('../fragments/PlaceOfDeath').default,
    PlaceOfDeathResidentialAddress: require('../fragments/PlaceOfDeathResidentialAddress').default,
    PlaceOfService: require('../fragments/PlaceOfService').default,
    PlaceOfViewingItems: require('../fragments/PlaceOfViewingItems').default,
    PurchaseOrders: require('../fragments/PurchaseOrders').default,
    ReferencePhoto: require('../fragments/ReferencePhoto').default,
    ReflectionMusicSongs: require('../fragments/ReflectionMusicSongs').default,
    ReflectionMusicians: require('../fragments/ReflectionMusicians').default,
    ReflectionRoom: require('../fragments/ReflectionRoom').default,
    RefreshmentsVenue: require('../fragments/RefreshmentsVenue').default,
    RslMasonic: require('../fragments/RslMasonic').default,
    RunsheetPDFs: require('../fragments/RunsheetPDFs').default,
    SpecialInstructions: require('../fragments/SpecialInstructions').default,
    TransferFrom: require('../fragments/TransferFrom').default,
    TransferFromResidentialAddress: require('../fragments/TransferFromResidentialAddress').default,
    ValuableItems: require('../fragments/ValuableItems').default,
    WebServiceLogs: require('../fragments/WebServiceLogs').default
};
